import React, { useState, useEffect } from "react";
import { useProperty } from "../context/PropertyContext";
import "../styles/Registro.css";

const Registro = ({ onConfigSave, property, setIsConfigLoaded }) => {
  const { setProperty } = useProperty();
  const [selectedDevice, setSelectedDevice] = useState("");
  const [error, setError] = useState("");
  const [devices, setDevices] = useState([]);
  const [loading, setLoading] = useState(true);

  // Cargar dispositivos y configuración previa
  useEffect(() => {
    const loadDevices = async () => {
      if (!property) {
        setError("No se ha seleccionado una propiedad válida");
        setLoading(false);
        return;
      }

      try {
        console.log(`Cargando dispositivos para propiedad: ${property}`);
        const module = await import(`../data/${property}/devices.js`);
        const loadedDevices = module.devices || [];
        setDevices(loadedDevices);
        setError("");

        // Cargar configuración previa si existe
        const savedConfig = localStorage.getItem("currentDeviceConfig");
        if (savedConfig) {
          try {
            const config = JSON.parse(savedConfig);
            if (
              config.Propiedad === property &&
              loadedDevices.some((device) => device.name === config.name)
            ) {
              setSelectedDevice(config.name);
              setIsConfigLoaded(true);
              onConfigSave(config);
              console.log(`Configuración previa encontrada para ${property}:`, config);
            } else {
              console.warn("Configuración previa no coincide con la propiedad actual");
              setSelectedDevice("");
            }
          } catch (error) {
            console.error("Error al parsear configuración guardada:", error);
            setError("Configuración previa inválida. Selecciona un nuevo dispositivo.");
          }
        }
      } catch (error) {
        console.error(`Error cargando dispositivos para ${property}:`, error);
        setError(`No se encontraron dispositivos para ${property}`);
        setDevices([]);
      } finally {
        setLoading(false);
      }
    };

    loadDevices();
  }, [property, setIsConfigLoaded, onConfigSave]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (loading) return;

    if (!selectedDevice) {
      setError("Por favor, selecciona un dispositivo.");
      return;
    }

    const deviceConfig = devices.find((device) => device.name === selectedDevice);
    if (!deviceConfig) {
      setError("Dispositivo no válido.");
      return;
    }

    const configToSave = {
      ...deviceConfig,
      activo: "Y",
      Propiedad: property,
      timestamp: new Date().toISOString(),
    };

    try {
      localStorage.setItem("currentDeviceConfig", JSON.stringify(configToSave));
      localStorage.setItem("currentProperty", property);
      console.log("Configuración guardada:", configToSave);
      setProperty(property);
      setIsConfigLoaded(true);
      onConfigSave(configToSave);
    } catch (error) {
      console.error("Error al guardar configuración:", error);
      setError("Error al guardar la configuración. Inténtalo de nuevo.");
    }
  };

  const handleResetConfig = () => {
    try {
      localStorage.removeItem("currentDeviceConfig");
      localStorage.removeItem("currentProperty");
      setSelectedDevice("");
      setIsConfigLoaded(false);
      setProperty(null);
      setError("Configuración restablecida. Selecciona un nuevo dispositivo.");
      console.log("Configuración restablecida para:", property);
    } catch (error) {
      console.error("Error al restablecer configuración:", error);
      setError("Error al restablecer la configuración. Inténtalo de nuevo.");
    }
  };

  if (loading) {
    return (
      <div className="registro-container">
        <div className="registro-card">
          <h1 className="registro-title">Cargando dispositivos...</h1>
        </div>
      </div>
    );
  }

  if (error && !loading) {
    return (
      <div className="registro-container">
        <div className="registro-card">
          <h1 className="registro-title">Error</h1>
          <p className="error-message">{error}</p>
          <button className="retry-button" onClick={() => window.location.reload()}>
            Reintentar
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="registro-container">
      <div className="registro-card">
        <h1 className="registro-title">Configuración del Dispositivo</h1>
        <p className="registro-subtitle">
          Propiedads: <strong>{property || "No seleccionada"}</strong>
        </p>

        {localStorage.getItem("currentDeviceConfig") && (
          <div className="saved-config-notice">
            <p>Configuración guardada encontrada para esta propiedad.</p>
            <button className="reset-button" onClick={handleResetConfig}>
              Restablecer Configuración
            </button>
          </div>
        )}

        <form onSubmit={handleSubmit} className="registro-form">
          <div className="form-group">
            <label htmlFor="deviceSelect" className="form-label">
              Dispositivo:
            </label>
            <select
              id="deviceSelect"
              value={selectedDevice}
              onChange={(e) => setSelectedDevice(e.target.value)}
              className="form-select"
              disabled={loading || devices.length === 0}
            >
              <option value="">Selecciona un dispositivo</option>
              {devices.map((device) => (
                <option key={device.name} value={device.name}>
                  {device.name} ({device.Rol})
                </option>
              ))}
            </select>
          </div>

          {error && <p className="error-message">{error}</p>}

          <div className="form-actions">
            <button
              type="submit"
              className="submit-button"
              disabled={loading || devices.length === 0 || !selectedDevice}
            >
              {loading ? "Cargando..." : "Guardar Configuración"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Registro;